import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import "./styles.css";
import * as XLSX from "xlsx";
import SearchableSelect from "./components/SearchableSelect";

import {API_BASE_URL} from "./config"

// Helper functions for the new format
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR');
};

const formatTime = (timeString) => {
  if (!timeString) return '';
  return timeString;
};

const getConfirmationStatus = (pointage) => {
  // This is a placeholder. Implement the actual logic based on your data structure
  return pointage.distEnt && pointage.distEnt < 100 ? 'GNR' : 'C';
};

const groupPointagesByMerchandiserAndDate = (pointages) => {
  const grouped = {};
  
  pointages.forEach(pointage => {
    const merchKey = `${pointage.merch || 'unknown'}::${pointage.name || 'Unknown Name'}`;
    const missionDate = pointage.missionDate?.split('T')[0] || 'unknown';
    
    if (!grouped[merchKey]) {
      grouped[merchKey] = {};
    }
    
    if (!grouped[merchKey][missionDate]) {
      grouped[merchKey][missionDate] = [];
    }
    
    grouped[merchKey][missionDate].push(pointage);
  });
  
  return grouped;
};
const PointagesComponent = () => {
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [userId, setUserId] = useState("");
  const [pointages, setpointages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [workers, setWorkers] = useState([]);

  const fetchWorkers = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}Merchandiser/GetMerchandisers`
      );
      setWorkers(response.data);
    } catch (error) {
      setError(error);
    }
  }, []);

  useEffect(() => {
    fetchWorkers();
  }, [fetchWorkers]);

  const fetchPointages = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${API_BASE_URL}Pointage/GetPointages`,
        { params: { date : date, merch: userId } }
      );
      setpointages(response.data);
    } catch (error) {
      console.error("Error fetching rapports:", error);
      setError("Erreur lors de la récupération des rapports.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPointages();
  }, [date, userId]);

  const handlePrint = () => window.print();

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(pointages);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Rapport Prix");
    XLSX.writeFile(workbook, "Pointages.xlsx");
  };


  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Rapport Pointage</h2>
      <div className="no-print">
        <div style={styles.formContainer}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Date:</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Marchandiseur:</label>
            <SearchableSelect
              options={workers}
              value={userId}
              onChange={setUserId}
              placeholder="Marchandiseur"
            />
          </div>
          <button onClick={handlePrint} style={styles.button}>
            <i className="bi bi-printer"></i>
          </button>
          <button onClick={exportToExcel} style={styles.button}>
            Exporter <i className="bi bi-file-earmark-spreadsheet"></i>
          </button>
        </div>
      </div>

{loading ? (
  <p style={styles.loading}>Loading...</p>
) : error ? (
  <p style={styles.error}>{error}</p>
) : pointages.length === 0 ? (
  <p style={styles.empty}>Aucun rapport à afficher.</p>
) : (
      <div>
        {/* Group pointages by merch and mission date */}
        {Object.entries(groupPointagesByMerchandiserAndDate(pointages)).map(([merchInfo, missions]) => {
          const [merchId, merchName] = merchInfo.split('::');
          return Object.entries(missions).map(([missionDate, pointagesByDate], missionIndex) => (
            <div key={`${merchId}-${missionDate}-${missionIndex}`} style={styles.missionContainer}>
              <div style={styles.missionHeader}>
                <div style={styles.missionInfo}>
                  <h4>Date Mission: {formatDate(missionDate)}</h4>
                  <h5>Description: {pointagesByDate[0]?.missionDescription || 'Facing & Rupture'}</h5>
                </div>

              </div>        
              <div style={styles.tableContainer}>
                              <div style={styles.merchandiserInfo}>
                  <h5>{merchId} : {merchName}</h5>
                </div>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Raison Social</th>
                      <th style={styles.th}>Gouv</th>
                      <th style={styles.th}>Delegation</th>
                      <th style={styles.th}>Class</th>
                      <th style={styles.th}>Heure arrivée</th>
                      <th style={styles.th}>Heure départ</th>
                      <th style={styles.th}>Longitude</th>
                      <th style={styles.th}>Lattitude</th>
                      <th style={styles.th}>Conf</th>
                      <th style={styles.th}>commentaire</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pointagesByDate.map((pointage, index) => (
                      <tr key={`${pointage.id || index}`}>
                        <td style={styles.td}>{pointage.raisonSocial}</td>
                        <td style={styles.td}>{pointage.gouvernorat}</td>
                        <td style={styles.td}>{pointage.delegation}</td>
                        <td style={styles.td}>{pointage.classement}</td>
                        <td style={styles.td}>{formatTime(pointage.heureArrivee)}</td>
                        <td style={styles.td}>{formatTime(pointage.heureDepart)}</td>
                        <td style={styles.td}>{pointage.longEnt}</td>
                        <td style={styles.td}>{pointage.lattEnt}</td>
                        <td style={styles.td}>{getConfirmationStatus(pointage)}</td>
                        <td style={styles.td}>{pointage.commentaire}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={styles.pageNumber}>Page 1 sur {Math.ceil(Object.keys(missions).length)}</div>
            </div>
          ));
        })}
      </div>
)}


    </div>
  );
};

const styles = {
  container: {
    padding: "15px",
    fontFamily: "Arial, sans-serif",
  },
  header: {
    color: "#333",
    marginBottom: "10px",
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "bold",
  },
  formContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    marginRight: "15px",
  },
  label: {
    marginBottom: "5px",
    fontWeight: "bold",
  },
  input: {
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid #ddd",
    width: "195px",
    boxSizing: "border-box",
  },
  button: {
    padding: "10px 20px",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#d6eaf8",
    fontSize: "16px",
    marginLeft: "10px",
    height: "40px",
    marginTop: "30px",
    alignItems: "center",
  },
  loading: {
    color: '#888',
    fontStyle: 'italic',
    textAlign: 'center',
    padding: '1rem',
  },
  error: {
    color: '#dc3545',
    textAlign: 'center',
    fontWeight: 'bold',
    padding: '1rem',
  },
  empty: {
    color: '#999',
    textAlign: 'center',
    fontStyle: 'italic',
    padding: '1rem',
  },
  missionContainer: {
    marginTop: '30px',
    pageBreakAfter: 'always',
  },
  missionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
  },
  missionInfo: {
    textAlign: 'left',
  },
  merchandiserInfo: {
    textAlign: 'left',
  },
  tableContainer: {
    backgroundColor: '#fff',
    padding: '1rem',
    borderRadius: '0',
    marginBottom: '2rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  heading: {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: '#333',
    fontFamily: 'Arial, sans-serif',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: '#fff',
    fontSize: '0.9rem',
  },
  th: {
    backgroundColor: '#f0f0f0',
    padding: '8px 10px',
    textAlign: 'left',
    border: '1px solid #ddd',
    fontWeight: '600',
    color: '#333',
    fontSize: '0.9rem',
  },
  td: {
    padding: '8px 10px',
    border: '1px solid #ddd',
    verticalAlign: 'middle',
    fontSize: '0.9rem',
  },
  pageNumber: {
    textAlign: 'right',
    marginTop: '10px',
    fontSize: '0.8rem',
    color: '#666',
  },
};


export default PointagesComponent;
